import React, { useEffect, useState } from "react";

import HistoryIcon from "@mui/icons-material/History";
import DataObjectIcon from "@mui/icons-material/DataObject";
import ReplayIcon from "@mui/icons-material/Replay";

import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

import { GridActionsCellItem } from "@mui/x-data-grid";

import { JsonDialog } from "./jsonDialog";
import { CustomPagination } from "../customPagination";
import { ConvertISOToDate } from "../util";

import ResponsiveGrid from "../grid/responsiveGrid";
import FlightHistoryDialog from "../manager/operations/flightHistoryDialog";
import FlightPlaybackDialog from "../manager/operations/flightPlaybackDialog";

const FlightLog = () => {
    const [flightData, setFlightData] = useState([]);
    const [selectedFlightHistoryFlight, setSelectedFlightHistoryFlight] = useState(null);
    const [selectedFlightJson, setSelectedFlightJson] = useState(null);
    const [flightPlaybackDialogUuid, setFlightPlaybackDialogUuid] = useState(null);

    const [sortModel, setSortModel] = useState([{ field: "date_updated", sort: "desc" }]);

    const columns = [
        {
            type: "actions",
            field: "actions",
            minWidth: 125,
            headerName: "",
            cellClassName: "actions",
            getActions: ({ row }) => {
                return [
                    <Tooltip key={1} title="View JSON">
                        <GridActionsCellItem icon={<DataObjectIcon />} label="View JSON" onClick={() => setSelectedFlightJson(row)} />
                    </Tooltip>,
                    <Tooltip key={2} title="View History">
                        <GridActionsCellItem icon={<HistoryIcon />} label="View History" onClick={() => setSelectedFlightHistoryFlight(row)} />
                    </Tooltip>,
                    <Tooltip key={3} title="View Replay">
                        <GridActionsCellItem icon={<ReplayIcon />} label="View Replay" onClick={() => setFlightPlaybackDialogUuid(row.flight_uuid)} />
                    </Tooltip>
                ];
            }
        },
        {
            field: "flight_uuid",
            headerName: "ID",
            flex: 1,
            minWidth: 275
        },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            minWidth: 150
        },
        {
            field: "state",
            headerName: "State",
            flex: 1,
            minWidth: 100
        },
        {
            field: "time_start",
            headerName: "Time Start",
            minWidth: 175,
            type: "dateTime",
            flex: 1,
            valueFormatter: (value) => `${ConvertISOToDate(value)}`
        },
        {
            field: "time_end",
            headerName: "Time End",
            minWidth: 175,
            type: "dateTime",
            flex: 1,
            valueFormatter: (value) => `${ConvertISOToDate(value)}`
        },
        {
            field: "owner",
            headerName: "Owner",
            minWidth: 150,
            flex: 1
        },
        {
            field: "organization",
            headerName: "Org",
            minWidth: 100,
            flex: 1
        },
        {
            field: "conflicts",
            headerName: "Conflicts",
            minWidth: 100,
            flex: 1,
            valueGetter: (value, row) => `${row.conflicts != "" ? "Yes" : ""}`
        },
        {
            field: "date_created",
            headerName: "Created",
            minWidth: 175,
            type: "dateTime",
            flex: 1,
            valueFormatter: (value) => `${ConvertISOToDate(value)}`
        },
        {
            field: "date_updated",
            headerName: "Updated",
            minWidth: 175,
            type: "dateTime",
            flex: 1,
            valueFormatter: (value) => `${ConvertISOToDate(value)}`
        }
    ];

    useEffect(() => {
        handleFetchFlightLogs();
    }, []);

    const handleFetchFlightLogs = async () => {
        try {
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            };
            const response = await fetch("api/op/getPlannedAndPublished", requestOptions);
            if (!response.ok) throw new Error(`An error occured while loading the flight history: ${response.statusText}`);

            const data = await response.json();
            setFlightData(data);
        } catch (err) {
            console.error("An error occured while trying to fetch the flight logs", err);
        }
    };
    return (
        <Box sx={{ height: 578 }}>
            <ResponsiveGrid
                primaryColumns={["name", "json"]}
                disableVirtualization
                rows={flightData}
                columns={columns}
                disableRowSelectionOnClick
                getRowId={(row) => row.flight_uuid}
                pagination
                slots={{ pagination: CustomPagination }}
                initialState={{ pagination: { paginationModel: { pageSize: 9 } } }}
                sortModel={sortModel}
                onSortModelChange={(model) => setSortModel(model)}
            />
            {selectedFlightHistoryFlight ? (
                <FlightHistoryDialog
                    selectedFlightHistoryFlight={selectedFlightHistoryFlight}
                    setSelectedFlightHistoryFlight={setSelectedFlightHistoryFlight}
                />
            ) : (
                <></>
            )}
            {selectedFlightJson ? (
                <JsonDialog jsonOpen={Boolean(selectedFlightJson)} setJsonOpen={setSelectedFlightJson} selectedJson={selectedFlightJson} />
            ) : (
                <></>
            )}
            {flightPlaybackDialogUuid ? (
                <FlightPlaybackDialog flightPlaybackDialogUuid={flightPlaybackDialogUuid} setFlightPlaybackDialogUuid={setFlightPlaybackDialogUuid} />
            ) : (
                <></>
            )}
        </Box>
    );
};

export default FlightLog;
